"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
/**
 * This component allows to maintain grid gap behaviour of PF Form by wrapping
 * FormGroup components which are inside of Grid
 */
const GridGap = (props) => react_1.default.createElement("div", Object.assign({}, props, { className: "pf-v5-c-form" }));
exports.default = GridGap;
//# sourceMappingURL=GridGap.js.map